export class EmployeeIndividual {
  inn: string;
  snils: string;
  bik: string;
  checking_account: string;
  bank_card: string;
}
